// extracted by mini-css-extract-plugin
export var container = "_b5-1";
export var cornerButtonContainer = "_b5-5";
export var disabled = "_b5-2";
export var fileContainer = "_b5-4";
export var hiddenInput = "_b5-3";
export var widthContainer = "_b5-0";